/**
 * 绩效等级颜色配置
 * 统一定义等级的主色、背景色、边框色、柱状图色和文字色
 */
export const GRADE_COLORS: Record<string, {
  color: string;
  bg: string;
  border: string;
  bar: string;
  text: string;
  bgSolid: string;
}> = {
  S: { color: '#722ed1', bg: 'rgba(114,46,209,0.08)', border: 'rgba(114,46,209,0.2)', bar: '#722ED1', text: '#722ed1', bgSolid: '#f5f0ff' },
  A: { color: '#00B42A', bg: 'rgba(0,180,42,0.08)', border: 'rgba(0,180,42,0.2)', bar: '#00B42A', text: '#00b42a', bgSolid: '#e8f7e8' },
  B: { color: '#3370FF', bg: 'rgba(51,112,255,0.08)', border: 'rgba(51,112,255,0.2)', bar: '#3370FF', text: '#3370ff', bgSolid: '#e8f3ff' },
  C: { color: '#FF7D00', bg: 'rgba(255,125,0,0.08)', border: 'rgba(255,125,0,0.2)', bar: '#FF7D00', text: '#ff7d00', bgSolid: '#fff7e8' },
  D: { color: '#F53F3F', bg: 'rgba(245,63,63,0.08)', border: 'rgba(245,63,63,0.2)', bar: '#F53F3F', text: '#f53f3f', bgSolid: '#ffece8' },
};

/** 获取等级颜色，不存在时返回默认灰色 */
export function getGradeColor(code: string) {
  return GRADE_COLORS[code] || { color: '#8f959e', bg: '#f7f8fa', border: '#e5e6eb', bar: '#8f959e', text: '#646a73', bgSolid: '#f0f1f5' };
}
